module.exports = __webpack_public_path__ + "img/7_38.29eff058.png";